import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

interface Particular {
  content: string | number
  description: string
}

interface Data {
  [key: string]: Particular | string | number
}

export const createIdentifier = async (data: Data): Promise<string> => {
  try {
    delete data.quantity
    const response = await axios.post(`/orders/products/identifier`, data)
    return response?.data
  } catch {
    toast.error('Não foi possível gerar identificador!', {
      toastId: 'orders-products-identifier'
    })
  }

  return ''
}

export function useCreateIdentifier(data: Data) {
  return useQuery(['createIdentifier', data], () => createIdentifier(data), {
    onError: () =>
      toast.error('Não foi possível carregar o pedido', {
        toastId: 'order'
      })
  })
}
